import React, { FunctionComponent } from "react";

import { LocalizationProvider } from "@multiweb/reactComponents";
import { createQA } from "@multiweb/reactUtils";
import { QAProps } from "@multiweb/types/react";

type WfOptionProps = {
    readonly locKey: string;
    readonly value: string | number | readonly string[] | undefined;
} & QAProps;

export const WfOption: FunctionComponent<WfOptionProps> = ({ locKey, value, qa }) => (
    <LocalizationProvider {...{ locKey }} >
        {({ text }) => (
            <option {...{ value, ...createQA(qa) }}>{text}</option>
        )}
    </LocalizationProvider>
);
